import { render } from "./AboutLRP.vue?vue&type=template&id=0592bf58&scoped=true"
import script from "./AboutLRP.vue?vue&type=script&lang=js"
export * from "./AboutLRP.vue?vue&type=script&lang=js"

import "./AboutLRP.vue?vue&type=style&index=0&id=0592bf58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0592bf58"]])

export default __exports__